import React from 'react'
import { FaExternalLink } from 'react-icons/lib/fa'

const link = "https://dashboard.twitch.tv/"
const twitchURIs = "https://stream.twitch.tv/ingests/"

const Twitch = props => {
    return <div className="help__Twitch">
        <h4>Setup Directions</h4>
        <ul>
            <li>Login to your Twitch account and go to your creator dashboard <strong><a target="_blank" href={link}>{link} <FaExternalLink/></a></strong></li>
            <li>In creator dashboard, click the menu in the upper-left corner and then select the Channel option. This will take you to a page with your Primary Stream Key, copy the <strong>Steam Key </strong> and paste it into <strong>Stream Key</strong> field above</li>
            <li>To retrieve the Server URL, find the nearest ingest location to you from <a target="_blank" href={twitchURIs}>this list <FaExternalLink/></a> provided by Twitch, copy
            up to the "../app/" eg. "rtmp://live-fra02.twitch.tv/app/" and paste it into the <strong>Server URL</strong> field above</li>
            <li>Click <strong>Add Target to Event</strong> below</li>
        </ul>
    </div>
}

export default Twitch